import { connect } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import BaseFeature from './BaseFeature';
import PropertyPicker from './components/PropertyPicker';
import { Trans } from 'react-i18next';

class DipSwitchCurrentSettings extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
        };

        this.availableDipCurrentProps = this.getAvailableDipCurrentProps();

        this.handleChange = this.handleChange.bind(this);

    }

    handleChange(propertyName, value) {
        const v = value;
        const newState = {[propertyName]:value};

        this.setState(newState);

        const state = { ...this.state, ...newState };

        this.props.handleChange(propertyName, v);
    }

    getAvailableDipCurrentProps() {
        let availableDipCurrentProps = [];
        for (let i = 0; ; i++) {
            let prop = "dscs.cur" + i;
            if(this.props.properties[prop]) {
                availableDipCurrentProps.push(prop);
            }
            else
                break;
        }
        return availableDipCurrentProps;
    }

    renderDipCurrent(property, key){
        return (
            <PropertyPicker
                property={this.props.properties[property]}
                title={this.props.properties[property].info.displayName + ""}
                margin="0.75rem auto"
                measureUnit={this.props.properties[property].info.unit}
                min={this.props.properties[property].valueMeta.min}
                max={this.props.properties[property].valueMeta.max}
                inputStyle={{ padding: "0", maxWidth: "auto", minWidth: '70px' }}
                titleSize={8}
                inputSize={2}
                step={1}
                handleChange={this.handleChange}
                key={key} />
        );
    }

    render() {
        return (
            <><Row>
                <Col lg={4} md={6} sm={12}>
                    <Card className="card-feature-component" style={{ width: '100%'}}>
                        <div className="card-header-feature">
                            {this.props.feature.displayName}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >

                            {this.availableDipCurrentProps.map((p, i) => this.renderDipCurrent(p, i))}

                            <Row className="unit-measure-current-setting" style={{ paddingTop: '0.75rem'}}>
                                <Col>{<Trans i18nKey="Minimum_Current" />}</Col>
                                <Col>{this.props.properties['dscs.cur0'].valueMeta.min} mA</Col>
                                <Col>{<Trans i18nKey="Maximum_Current" />}:</Col>
                                <Col>{this.props.properties['dscs.cur0'].valueMeta.max} mA</Col>
                            </Row>

                        </Card.Body>
                    </Card>
                </Col>
            </Row></>
        );
    }

}

export default connect(
    // mapStateToProps,
    // mapDispatchToProps
)(DipSwitchCurrentSettings);
